import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Sidebar } from 'react-frontier';

interface EntitySidebarProps {
	idParam: string,
	basePath: string,
	label: string,
}

var EntitySidebar = ({ idParam, basePath, label }: EntitySidebarProps)=>{
	var params = useParams();
	var navigate = useNavigate();
	var location = useLocation();

	var id = params[idParam];
	var base = `/${basePath}/${id}`;

	return <>
		<Sidebar.Item text='Regresar' iconName='arrow-left' onClick={()=>navigate(-1)} />
		<div className='divider'>{label} #{id}</div>
		<Sidebar.Item as={Link} to={base} text='Información' iconName='circle-info' active={location.pathname===base} />
		<Sidebar.Item as={Link} to={`${base}/form`} text='Formulario' iconName='file-alt' active={location.pathname.startsWith(`${base}/form`)} />
		{basePath==='promoters' && (
			<Sidebar.Item as={Link} to={`${base}/events`} text='Eventos' iconName='calendar' active={location.pathname.startsWith(`${base}/events`)} />
		)}
		{basePath==='promoters' && (
			<Sidebar.Item as={Link} to={`${base}/conditions`} text='Condiciones' iconName='clipboard-list' active={location.pathname.startsWith(`${base}/conditions`)} />
		)}
		{basePath==='promoters' && (
			<Sidebar.Item as={Link} to={`${base}/surveys`} text='Encuestas' iconName='clipboard-question' active={location.pathname.startsWith(`${base}/surveys`)} />
		)}
		<Sidebar.Item as={Link} to={`${base}/evidences`} text='Evidencias' iconName='file' active={location.pathname.startsWith(`${base}/evidences`)} />
	</>
}

export default EntitySidebar;
